// TODO fix circular dependencies
/* eslint-disable import/no-cycle */
import { CurrencyCode } from '@/constants/general';
import { CurrencyVo } from '../value-objects/currency.vo';

export const CURRENCIES_MAP: Record<CurrencyCode, CurrencyVo> = {
  [CurrencyCode.AUD]: new CurrencyVo({
    code: CurrencyCode.AUD,
    zeroDecimal: false,
  }),
  [CurrencyCode.BRL]: new CurrencyVo({
    code: CurrencyCode.BRL,
    zeroDecimal: false,
  }),
  [CurrencyCode.CAD]: new CurrencyVo({
    code: CurrencyCode.CAD,
    zeroDecimal: false,
  }),
  [CurrencyCode.CNY]: new CurrencyVo({
    code: CurrencyCode.CNY,
    zeroDecimal: false,
  }),
  [CurrencyCode.CZK]: new CurrencyVo({
    code: CurrencyCode.CZK,
    zeroDecimal: false,
  }),
  [CurrencyCode.DKK]: new CurrencyVo({
    code: CurrencyCode.DKK,
    zeroDecimal: false,
  }),
  [CurrencyCode.EUR]: new CurrencyVo({
    code: CurrencyCode.EUR,
    zeroDecimal: false,
  }),
  [CurrencyCode.HKD]: new CurrencyVo({
    code: CurrencyCode.HKD,
    zeroDecimal: false,
  }),
  [CurrencyCode.ILS]: new CurrencyVo({
    code: CurrencyCode.ILS,
    zeroDecimal: false,
  }),
  [CurrencyCode.MYR]: new CurrencyVo({
    code: CurrencyCode.MYR,
    zeroDecimal: false,
  }),
  [CurrencyCode.MXN]: new CurrencyVo({
    code: CurrencyCode.MXN,
    zeroDecimal: false,
  }),
  [CurrencyCode.NOK]: new CurrencyVo({
    code: CurrencyCode.NOK,
    zeroDecimal: false,
  }),
  [CurrencyCode.PHP]: new CurrencyVo({
    code: CurrencyCode.PHP,
    zeroDecimal: false,
  }),
  [CurrencyCode.PLN]: new CurrencyVo({
    code: CurrencyCode.PLN,
    zeroDecimal: false,
  }),
  [CurrencyCode.GBP]: new CurrencyVo({
    code: CurrencyCode.GBP,
    zeroDecimal: false,
  }),
  [CurrencyCode.SGD]: new CurrencyVo({
    code: CurrencyCode.SGD,
    zeroDecimal: false,
  }),
  [CurrencyCode.SEK]: new CurrencyVo({
    code: CurrencyCode.SEK,
    zeroDecimal: false,
  }),
  [CurrencyCode.CHF]: new CurrencyVo({
    code: CurrencyCode.CHF,
    zeroDecimal: false,
  }),
  [CurrencyCode.THB]: new CurrencyVo({
    code: CurrencyCode.THB,
    zeroDecimal: false,
  }),
  [CurrencyCode.USD]: new CurrencyVo({
    code: CurrencyCode.USD,
    zeroDecimal: false,
  }),
  [CurrencyCode.NZD]: new CurrencyVo({
    code: CurrencyCode.NZD,
    zeroDecimal: false,
  }),

  // Currencies with zero decimals are temporarily disabled.
  // [CurrencyType.JPY]: new CurrencyVo({ code: CurrencyType.JPY, zeroDecimal: true }),
  // [CurrencyType.HUF]: new CurrencyVo({ code: CurrencyType.HUF, zeroDecimal: true }),
  // [CurrencyType.TWD]: new CurrencyVo({ code: CurrencyType.TWD, zeroDecimal: true }),
};

export const DEFAULT_CURRENCY = CURRENCIES_MAP[CurrencyCode.USD];

export const getCurrencyByCode = (code: CurrencyCode) => {
  return CURRENCIES_MAP[code];
};
